import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';

import { AuthService } from '../../states/auth/services/auth.service';

export const authGuard: CanMatchFn = () => {
  const authService = inject(AuthService);
  const location = inject(Location);
  const isLoggedIn = authService.isLoggedIn;

  if (!isLoggedIn) {
    // Use the real browser URL so query params (and base href) are
    // preserved; route segments alone drop the query string.
    authService.signOut(location.path(true) || undefined, false);
  }

  return isLoggedIn;
};
